import { Component } from '@angular/core';
import { UserDataService } from './providers/userData/user-data.service';
import { environment } from 'src/environments/environment';
import { AlertController, ModalController, NavController, Platform } from '@ionic/angular';
import { App } from '@capacitor/app';
import '@capacitor-community/safe-area';
import { SafeArea } from '@capacitor-community/safe-area';
import { includes } from 'lodash';
import type { OverlayEventDetail } from '@ionic/core';
import { FormsModule } from '@angular/forms'; //added

import { DashboardService } from './providers/dashboard/dashboard.service';
import { MetadataService } from './providers/metadata/metadata.service';
import { ActivatedRoute, Router } from '@angular/router';
import { FormsSharingService } from './providers/forms/formsSharing/forms-sharing.service';
import { EsupportMappingService } from './providers/esupport/esupport-mapping.service';
import { UserProfileService } from './providers/userProfile/user-profile.service';
import { YearCollegeTypeMappingService } from './providers/yearCollegeMapping/year-college-type-mapping.service';
import { YearManagementPage } from './pages/year-management/year-management.page';
import { LogoutConfirmationModalComponent } from './components/logout-confirmation-modal/logout-confirmation-modal.component';
import {
	ADMIN_MENU_ITEMS,
	FACILITATOR_INBOX_MENU,
	GREEN_MENU_ITEMS,
	IQAC_CO_ADMINMENU_ITEMS,
	IQAC_MENU_ITEMS,
	LIBRARY_MENU_ITEMS,
	LOGIN_MENU_ITEM,
	MENU_ITEMS,
	MenuItem,
	MY_PROFILE_MENU,
	OFFICE_CO_MENU_ITEMS,
	PERSONAL_INBOX_MENU,
	PHY_EDU_MENU_ITEMS,
	PUBLIC_MENU_ITEMS,
	SUPER_USER_MENU_ITEMS,
	WEB_CO_INBOX_MENU,
	HELPDESK_MENU_ITEM
} from './navigation/MenuItem';
import { AuthenticationService } from './providers/authentication/authentication.service';
import { Capacitor } from '@capacitor/core';
import { version as webVersion } from 'src/environments/version';

declare var $: any;

const firebaseConfig = {
	apiKey: environment.firebaseConfig.apiKey,
	authDomain: environment.firebaseConfig.authDomain,
	projectId: environment.firebaseConfig.projectId,
	storageBucket: environment.firebaseConfig.storageBucket,
	messagingSenderId: environment.firebaseConfig.messagingSenderId,
	appId: environment.firebaseConfig.appId,
	measurementId: environment.firebaseConfig.measurementId
};

// Initialize Firebase // FIXME
// const app = initializeApp(firebaseConfig); // TODO Initiazlie firebase

@Component({
	selector: 'app-root',
	templateUrl: 'app.component.html',
	styleUrls: ['app.component.scss'],
	standalone: false
})
export class AppComponent {
	// private _storage: Storage | null = null;

	app_version: string = webVersion;
	isBetaVersion: boolean = false;
	isBlackListedVersion: boolean = false;
	isLoggedIn: boolean = false;
	profile: any = {
		name: ''
	};
	superUserLogin: boolean = false;
	isIQACADMIN: boolean = false;
	isIQACCOADMIN: boolean = false;
	isIQACCOADMINOnly: boolean = false;
	subscriptionStatus: string;
	webc: boolean = false;
	public selectedIndex = 0;
	uuid: any;
	personalSectionForms = [];
	departmentSectionForms = [];
	iqacSectionForms = [];
	officeCoSectionForms = [];
	librarySectionForms = [];
	greenInitiativesSectionForms = [];
	physicalEducationSportsSectionForms = [];

	iqacSectionAllowed = false;
	collegeAdminAllowed = false;
	onlyCollegeAdminAllowed = false;
	departmentSectionAllowed = false;
	personalSectionAllowed = false;
	officeCoSectionAllowed = false;
	librarySectionAllowed = false;
	greenInitiativesSectionAllowed = false;
	physicalEducationSportsSectionAllowed = false;
	isFacilitator: boolean = false;

	allotedDepartmentList = [];
	sharedFormCount: number = 0;
	isDesktop = false;
	isMobileApp = false;
	metadata: any = {};
	isExpired: boolean = true;
	quotaExhausted: boolean = true;
	os: any = 'Web';
	skipStatus: boolean;
	response: any;
	collegeId: any;
	userProfile: any = {};
	profileCompletion: any;
	isProfileCompletionCheck: boolean = false;
	yearMappingLength: any;

	activeSection: any;
	currentCriteria: any;
	allowedCrietrias: any = [];
	criteriaOrdinatorAllowed: boolean = false;

	menuItems = MENU_ITEMS;
	applicableMenuItems: MenuItem[] = [];
	menuItemsLoading: boolean = true;
	private loginListenersAdded = false;
	private inboxListenersAdded = false;
	/** Set while a rejected token is signing the user out, so the many failing calls trigger it only once. */
	private forcingLogout = false;

	constructor(
		private platform: Platform,
		private authenticationService: AuthenticationService,
		// private splashScreen: SplashScreen, // TODO handle splash
		// private statusBar: StatusBar,// TODO handle status bar
		public userDataService: UserDataService,
		private dashboardService: DashboardService,
		public metadataService: MetadataService,
		public alertController: AlertController,
		public router: Router,
		public route: ActivatedRoute,
		public formsSharingService: FormsSharingService,
		public navController: NavController,
		public esupportMappingService: EsupportMappingService,
		public userProfileService: UserProfileService,
		// private appVersion: AppVersion,
		// private market: Market, // TODO check about play store redirection
		// private storage: Storage,
		// private fcm: FCM,
		public modalController: ModalController,
		public collegeTypeYearMappingService: YearCollegeTypeMappingService
	) {
		// this.initStorage();

		this.initializeApp(); //TODO Initialize Firebase Application
		// window["FreshworksWidget"]("hide"); // TODO Freshwork handling
		const launcherFrame = document.getElementById('launcher-frame');
		if (launcherFrame != null) {
			launcherFrame.style.maxWidth = '80px';
			launcherFrame.style.minWidth = '86px';
		}
	}
	// async initStorage() {
	//   this._storage = await this.storage.create();
	// }

	public actionSheetButtons = [
		{
			text: 'Logout',
			role: 'destructive',
			color: 'danger',
			data: {
				action: 'logout'
			}
		},
		{
			text: 'Cancel',
			role: 'cancel',
			data: {
				action: 'cancel'
			}
		}
	];

	logResult(event: CustomEvent<OverlayEventDetail>) {
		if (event && event.detail && event.detail.data && event.detail.data.action === 'logout') {
			console.log(JSON.stringify(event.detail, null, 2));
			this.logout();
		}
	}

	toggleSubMenu(item: MenuItem) {
		if (item.children) {
			item.expanded = !item.expanded;
		}
	}
	initializeApp() {
		this.platform.ready().then(async () => {
			// this.statusBar.styleLightContent();
			// this.splashScreen.hide();
			if (Capacitor.isNativePlatform()) {
				console.log('In getCurrentAppVersion() ');
				const appInfo = await App.getInfo();
				console.log(`App version - ${appInfo.version}`);
				this.app_version = appInfo.version;
			}
			this.betaVersionCheck();
			if (this.platform.is('desktop')) {
				this.isDesktop = true;
			}
			if (
				this.platform.is('android') ||
				this.platform.is('ios') ||
				this.platform.is('mobile') ||
				this.platform.is('iphone')
			) {
				this.isMobileApp = true;
			}
			if (this.platform.is('android')) {
				this.os = 'android';
			} else if (this.platform.is('ios')) {
				this.os = 'ios';
			}
		});

		$(document).ready(() => {
			$(document).click(() => {
				($('.navbar-collapse') as any).collapse('hide');
			});
		});
	}

	getFormLiteInfoForLoggedInUser() {
		this.userDataService.isLoggedIn().then((loggedIn) => {
			if (loggedIn) {
				this.userDataService.getStoredLiteForm().then((formList) => {
					if (formList) {
						this.sharedFormCount = formList.length;
						this.userDataService.saveSharedLiteForm(formList);
					}
				});
			}
		});
	}

	async loadMetadata() {
		const metadata = await this.metadataService.getMetadataAxios();
		this.metadata = metadata;
		console.log('Navigation: loadMetadata() ');
		await this.segregateSectionWiseFormList();
		this.userDataService.saveMetadata(metadata);

		const mappings = await this.esupportMappingService.readESupportMetricMappingAxios();
		await this.userDataService.saveMetricdata(mappings);
	}

	public initMenuItems() {
		this.applicableMenuItems = [];

		// Execute immediately without setTimeout
		PUBLIC_MENU_ITEMS.forEach((m) => this.applicableMenuItems.push(m));
		if (!this.isLoggedIn) {
			console.log(`Navigation: Logged In`);
			LOGIN_MENU_ITEM.forEach((m) => this.applicableMenuItems.push(m));
		}

		// Super User
		if (this.isLoggedIn && this.superUserLogin) {
			console.log(`Navigation: Super User`);
			SUPER_USER_MENU_ITEMS.forEach((m) => this.applicableMenuItems.push(m));
		}

		if (
			this.isIQACADMIN &&
			!this.isIQACCOADMINOnly &&
			!this.onlyCollegeAdminAllowed &&
			this.isLoggedIn &&
			this.subscriptionStatus != 'ONBOARDED'
		) {
			// IQAC Action Menus
			console.log(`Navigation: IQAC`);
			const iqacMenu: MenuItem = {
				title: 'IQAC',
				icon: 'fa-solid fa-gears',
				expanded: false,
				children: []
			};
			IQAC_MENU_ITEMS.forEach((m) => {
				iqacMenu.children.push(m);
			});
			this.applicableMenuItems.push(iqacMenu);

			// IQAC Form Menus
			const iqacFormMenu: MenuItem = {
				title: 'Create IQAC Forms',
				icon: 'fas fa-edit',
				expanded: false,
				children: []
			};
			this.iqacSectionForms.forEach((section) => {
				const sectionCreateFormMenu: MenuItem = {
					title: section.label,
					url: `/form-navigation/${section.id}/undefined`,
					icon: 'fab fa-wpforms'
				};
				iqacFormMenu.children.push(sectionCreateFormMenu);
			});
			this.applicableMenuItems.push(iqacFormMenu);
		}
		if (this.isIQACCOADMIN && this.isIQACCOADMINOnly && this.isLoggedIn) {
			console.log(`Navigation: IQAC CO-ADMIN`);
			IQAC_CO_ADMINMENU_ITEMS.forEach((m) => this.applicableMenuItems.push(m));
			const iqacFormMenu: MenuItem = {
				title: 'Create IQAC Forms',
				icon: 'fas fa-edit',
				expanded: false,
				children: []
			};
			this.iqacSectionForms.forEach((section) => {
				const sectionCreateFormMenu: MenuItem = {
					title: section.label,
					url: `/form-navigation/${section.id}/undefined`,
					icon: 'fab fa-wpforms'
				};
				iqacFormMenu.children.push(sectionCreateFormMenu);
			});
			this.applicableMenuItems.push(iqacFormMenu);
		}

		// ADMINS
		if (this.isLoggedIn && this.collegeAdminAllowed) {
			console.log(`Navigation: ADMINS`);
			ADMIN_MENU_ITEMS.forEach((m) => this.applicableMenuItems.push(m));
		}

		if (this.officeCoSectionAllowed && !this.superUserLogin && this.isLoggedIn && this.profile) {
			console.log(`Navigation: OFFICE`);
			OFFICE_CO_MENU_ITEMS.forEach((m) => this.applicableMenuItems.push(m));
			const secondLevelMenuHeading: MenuItem = {
				title: 'Create Office Forms',
				icon: 'fas fa-edit',
				expanded: false,
				children: []
			};
			this.officeCoSectionForms.forEach((section) => {
				const sectionCreateFormMenu: MenuItem = {
					title: section.label,
					url: `/form-navigation/${section.id}/undefined`,
					icon: 'fab fa-wpforms'
				};
				secondLevelMenuHeading.children.push(sectionCreateFormMenu);
			});
			this.applicableMenuItems.push(secondLevelMenuHeading);
		}

		// Library
		if (this.librarySectionAllowed && !this.superUserLogin && this.isLoggedIn && this.profile) {
			console.log(`Navigation: LIB`);
			LIBRARY_MENU_ITEMS.forEach((m) => this.applicableMenuItems.push(m));
			const secondLevelMenuHeading: MenuItem = {
				title: 'Create Library Forms',
				icon: 'fas fa-edit',
				expanded: false,
				children: []
			};
			this.librarySectionForms.forEach((section) => {
				const sectionCreateFormMenu: MenuItem = {
					title: section.label,
					url: `/form-navigation/${section.id}/undefined`,
					icon: 'fab fa-wpforms'
				};
				secondLevelMenuHeading.children.push(sectionCreateFormMenu);
			});
			this.applicableMenuItems.push(secondLevelMenuHeading);
		}

		// Green
		if (this.greenInitiativesSectionAllowed && !this.superUserLogin && this.isLoggedIn && this.profile) {
			console.log(`Navigation: GREEN`);
			GREEN_MENU_ITEMS.forEach((m) => this.applicableMenuItems.push(m));
			const secondLevelMenuHeading: MenuItem = {
				title: 'Green Initiatives Forms',
				icon: 'fas fa-edit',
				expanded: false,
				children: []
			};
			this.greenInitiativesSectionForms.forEach((section) => {
				const sectionCreateFormMenu: MenuItem = {
					title: section.label,
					url: `/form-navigation/${section.id}/undefined`,
					icon: 'fab fa-wpforms'
				};
				secondLevelMenuHeading.children.push(sectionCreateFormMenu);
			});
			this.applicableMenuItems.push(secondLevelMenuHeading);
		}

		// Sports
		if (this.physicalEducationSportsSectionAllowed && !this.superUserLogin && this.isLoggedIn && this.profile) {
			console.log(`Navigation: SPORTS`);
			PHY_EDU_MENU_ITEMS.forEach((m) => this.applicableMenuItems.push(m));
			const secondLevelMenuHeading: MenuItem = {
				title: 'Create Physical Edu. Forms',
				icon: 'fa-solid fa-volleyball',
				expanded: false,
				children: []
			};
			this.physicalEducationSportsSectionForms.forEach((section) => {
				const sectionCreateFormMenu: MenuItem = {
					title: section.label,
					url: `/form-navigation/${section.id}/undefined`,
					icon: 'fab fa-wpforms'
				};
				secondLevelMenuHeading.children.push(sectionCreateFormMenu);
			});
			this.applicableMenuItems.push(secondLevelMenuHeading);
		}

		if (this.departmentSectionAllowed && !this.superUserLogin && this.isLoggedIn) {
			console.log(`Navigation: DEPT`);
			this.allotedDepartmentList.forEach((department) => {
				const deptInboxMenu = {
					title: department.name,
					url: `/shared-form-inbox/${department.id}`,
					icon: 'fas fa-inbox'
				};
				this.applicableMenuItems.push(deptInboxMenu);

				// Add Deprtment's Form Creation Menu
				const secondLevelMenuHeading: MenuItem = {
					title: `Create ${department.name} Forms`,
					icon: 'fas fa-edit',
					expanded: false,
					children: []
				};
				this.departmentSectionForms.forEach((section) => {
					const sectionCreateFormMenu: MenuItem = {
						title: section.label,
						url: `/form-navigation/${section.id}/${department.id}`,
						icon: 'fab fa-wpforms'
					};
					secondLevelMenuHeading.children.push(sectionCreateFormMenu);
				});
				this.applicableMenuItems.push(secondLevelMenuHeading);
			});
		}

		// PERSONAL SECTION
		if (
			this.personalSectionAllowed &&
			!this.superUserLogin &&
			this.isLoggedIn &&
			this.personalSectionForms.length > 0
		) {
			console.log(`Navigation: PERSONAL`);
			PERSONAL_INBOX_MENU.forEach((m) => this.applicableMenuItems.push(m));
			const secondLevelMenuHeading: MenuItem = {
				title: 'Create Personal Forms',
				icon: 'fa-solid fa-pen-fancy',
				expanded: false,
				children: []
			};
			this.personalSectionForms.forEach((section) => {
				const sectionCreateFormMenu: MenuItem = {
					title: section.label,
					url: `/form-navigation/${section.id}/undefined`,
					icon: 'fab fa-wpforms'
				};
				secondLevelMenuHeading.children.push(sectionCreateFormMenu);
			});
			this.applicableMenuItems.push(secondLevelMenuHeading);
		}

		// All Applicable Criteris Inboxes
		if (this.criteriaOrdinatorAllowed && this.profile && this.isLoggedIn) {
			console.log(`Navigation: CRITERION`);
			this.allowedCrietrias.forEach((criteria: string) => {
				const criteriaInboxMenu = {
					title: `Criteria ${criteria} Inbox`,
					url: `/criteria-dashboard/${criteria}`,
					icon: 'fa-solid fa-bookmark'
				};
				this.applicableMenuItems.push(criteriaInboxMenu);
			});
			if (!this.applicableMenuItems.some((m) => m.url === '/aqar')) {
				this.applicableMenuItems.push({ title: 'AQAR', url: '/aqar', icon: 'fas fa-clipboard-check' });
			}
		}

		// WEB CO
		if (this.isLoggedIn && this.webc) {
			console.log(`Navigation: WEB`);
			WEB_CO_INBOX_MENU.forEach((m) => this.applicableMenuItems.push(m));
		}

		// FACILITATOR_INBOX_MENU
		if (this.isLoggedIn && this.isFacilitator) {
			console.log(`Navigation: FACILITATOR`);
			FACILITATOR_INBOX_MENU.forEach((m) => this.applicableMenuItems.push(m));
		}

		if (this.isLoggedIn) {
			console.log(`Navigation: PROFILE`);
			MY_PROFILE_MENU.forEach((m) => this.applicableMenuItems.push(m));
		}
		if (this.isLoggedIn) {
			HELPDESK_MENU_ITEM.forEach((m) => {
				if (!this.applicableMenuItems.some((item) => item.title === m.title)) {
					this.applicableMenuItems.push(m);
				}
			});
		}

		console.log(`Navigation: Menu Loading STOPPED`);
		this.menuItemsLoading = false;
		// console.log(`Navigation: ${JSON.stringify(this.applicableMenuItems, null, 2)}`);
	}

	async init() {
		console.log(`Navigation: Menu Loading Started`);
		this.menuItemsLoading = true;

		// Listen before the first API call: with a rejected token those calls fail, and a 'user:force-logout'
		// sent before the listener exists (or after init() fails) would be lost, leaving an empty dashboard.
		this.listenForLoginEvents();
		this.listenForLoginEventsForInbox();

		try {
			// Cache-first strategy: Load from storage first for immediate rendering
			// const cachedProfile = await this.userDataService.getUserProfile();
			// const cachedMetadata = await this.userDataService.getMetadata();
			// const cachedRoles = await this.userDataService.getLoggedInUserRole();

			// if (cachedProfile && cachedMetadata && cachedRoles) {
			// 	// Use cached data to render menus immediately
			// 	this.profile = cachedProfile;
			// 	this.metadata = cachedMetadata;
			// 	await this.checkLoginStatus();
			// 	this.segregateSectionWiseFormList();
			// 	console.log(`Navigation: Initializing Menu Items From Cached Data`);
			// 	this.initMenuItems();
			// }

			// Load fresh data in parallel in the background
			console.log('Navigation: init()');
			(await this.fetchuserProfile(), await this.loadMetadata());
			await this.checkLoginStatus();
			await this.checkwhichUserIsLogin();
			await this.fetchUpdatedProfile();
			await this.formQuota();
			await this.segregateSectionWiseFormList();
			console.log(`Navigation: Initializing Menu Items from init()`);
			this.initMenuItems();
		} catch (error) {
			console.error('Error in init:', error);
			// Ensure menus are initialized even on error
			console.log(`Navigation: Initializing Menu Items From Cache Block 2`);
			this.initMenuItems();
		}
	}

	async ngOnInit() {
		this.applySafeArea();
		await this.userDataService.initStorage();
		await this.init();
		this.authenticationService.loginStatusChange().subscribe((loggedIn) => {
			if (loggedIn) {
				this.isLoggedIn = true;
			} else {
				this.isLoggedIn = false;
			}
			console.log(`Initializing Menu Items From Login Status changed = ${loggedIn}`);
			this.initMenuItems();
		});
	}

	getProfileCompletionDetails() {
		this.userDataService.getToken().then((token) => {
			if (token) {
				this.userProfileService.getProfileCompletionDetails(token).subscribe((response) => {
					this.userDataService.saveProfileCompletiondata(response);
					this.profileCompletion = response;
					if (
						0 < this.profileCompletion.commitee &&
						0 < this.profileCompletion.department &&
						0 < this.profileCompletion.staff &&
						0 < this.profileCompletion.yearMapping
					) {
						this.isProfileCompletionCheck = true;
					}
				});
			}
		});
	}

	fetchAllCollegeTypeYearMappingsForCollegeId() {
		this.userDataService.getUserProfile().then((profile) => {
			this.collegeId = profile.college.id;
		});

		this.userDataService.getToken().then((token) => {
			this.collegeTypeYearMappingService
				.fetchCollegeTypeYearMapping(token, {
					collegeId: this.collegeId
				})
				.subscribe(
					(response) => {
						this.yearMappingLength = response.mappings.length;

						if (this.yearMappingLength < 1 || this.yearMappingLength == undefined) {
							if (this.subscriptionStatus == 'SUBS_ACTIVE') {
								this.openYearMappingModal();
							}
						}
					},
					(error) => {}
				);
		});
	}

	async openYearMappingModal() {
		const modal = await this.modalController.create({
			component: YearManagementPage,
			componentProps: {},
			backdropDismiss: false,
			cssClass: 'modal-fullscreen'
		});
		modal.present();
	}

	async betaVersionCheck() {
		console.log('In betaVersionCheck() ');
		this.userDataService.setIsSkipUpdate(false);
		if (this.app_version != undefined && this.os != undefined) {
			this.userDataService.getIsSkipUpdate().then((status) => {
				this.skipStatus = status;
			});

			this.userProfileService.getAppVersionStatusList(this.os, this.app_version).subscribe(
				(response) => {
					response.forEach((versionStatus) => {
						if (versionStatus?.isBeta) {
							this.isBetaVersion = true;
						}

						if (versionStatus?.status == 'BLACKLISTED') {
							this.blackListedVersionAlert();
						}
						if (versionStatus?.status == 'SUPPORTED') {
							if (!this.skipStatus) {
								this.supportedVersionAlert();
							}
						}
					});
				},
				(error: any) => {
					console.log('error is :', error);
				}
			);
		}
	}

	romanStringToInt(romanString) {
		const romanMap = {
			I: 1,
			II: 2,
			III: 3,
			IV: 4,
			V: 5,
			VI: 6,
			VII: 7
		};

		return romanMap[romanString];
	}
	async segregateSectionWiseFormList() {
		console.log('Navigation: In segregateSectionWiseFormList()');
		this.personalSectionForms = [];
		this.iqacSectionForms = [];
		this.departmentSectionForms = [];
		this.allotedDepartmentList = [];
		this.physicalEducationSportsSectionForms = [];
		this.greenInitiativesSectionForms = [];
		this.officeCoSectionForms = [];
		this.librarySectionForms = [];
		this.allowedCrietrias = [];

		this.iqacSectionAllowed = false;
		this.departmentSectionAllowed = false;
		this.personalSectionAllowed = false;
		this.officeCoSectionAllowed = false;
		this.librarySectionAllowed = false;
		this.greenInitiativesSectionAllowed = false;
		this.physicalEducationSportsSectionAllowed = false;

		const roles = await this.userDataService.getLoggedInUserRole();

		if (roles) {
			if (roles.includes('FACILITATOR')) {
				this.isFacilitator = true;
			} else {
				this.isFacilitator = false;
			}
			/* if (roles.includes("PRINCIPAL_EQUI") || roles.includes("COLL_MGMT")) {
          this.collegeAdminAllowed = true;
        } else {
          this.collegeAdminAllowed = false;
        } */
			this.metadata.formSections.forEach((section) => {
				let allowedDesignations = section.designationList.split(',');

				let sectionName = section.label;
				if (sectionName === 'Department') {
					this.departmentSectionForms.push(section);
					roles.forEach((roleOfLoggedInUser) => {
						if (!this.departmentSectionAllowed && allowedDesignations.includes(roleOfLoggedInUser)) {
							this.departmentSectionAllowed = true;
						}
					});
					if (this.departmentSectionAllowed) {
						if (this.profile.responsiblities)
							this.profile.responsiblities.forEach((responsiblity) => {
								if (responsiblity) {
									if (
										responsiblity.designation == 'HEAD_OF_DEPT' &&
										responsiblity.department &&
										!responsiblity.department.deleted
									) {
										this.allotedDepartmentList.push(responsiblity.department);
									}
								}
							});
					}
				}
				if (sectionName === 'IQAC') {
					this.iqacSectionForms.push(section);
					roles.forEach((roleOfLoggedInUser) => {
						if (!this.iqacSectionAllowed && allowedDesignations.includes(roleOfLoggedInUser)) {
							this.iqacSectionAllowed = true;
						}
					});
				}
				if (sectionName === 'Office & Accounts') {
					this.officeCoSectionForms.push(section);
					roles.forEach((roleOfLoggedInUser) => {
						if (!this.officeCoSectionAllowed && allowedDesignations.includes(roleOfLoggedInUser)) {
							this.officeCoSectionAllowed = true;
						}
					});
				}

				if (sectionName === 'Library') {
					this.librarySectionForms.push(section);
					roles.forEach((roleOfLoggedInUser) => {
						if (!this.librarySectionAllowed && allowedDesignations.includes(roleOfLoggedInUser)) {
							this.librarySectionAllowed = true;
						}
					});
				}

				if (sectionName === 'Green Initiatives') {
					this.greenInitiativesSectionForms.push(section);
					roles.forEach((roleOfLoggedInUser) => {
						if (!this.greenInitiativesSectionAllowed && allowedDesignations.includes(roleOfLoggedInUser)) {
							this.greenInitiativesSectionAllowed = true;
						}
					});
				}

				if (sectionName === 'Physical Education & Sports') {
					this.physicalEducationSportsSectionForms.push(section);
					roles.forEach((roleOfLoggedInUser) => {
						if (!this.physicalEducationSportsSectionAllowed && allowedDesignations.includes(roleOfLoggedInUser)) {
							this.physicalEducationSportsSectionAllowed = true;
						}
					});
				}

				// TODO to add - Lib, Sports, Green
				if (
					includes(
						[
							'Personal',
							'Activities',
							'Admission, Examination, Progression & Support',
							'Services, Facilities & Infrastructure'
						],
						sectionName
					)
				) {
					this.personalSectionForms.push(section);
					roles.forEach((roleOfLoggedInUser) => {
						if (!this.personalSectionAllowed && allowedDesignations.includes(roleOfLoggedInUser)) {
							this.personalSectionAllowed = true;
						}
					});
				}
			});
		}

		let iqac = false;
		let admin = false;
		this.collegeAdminAllowed = false;
		if (this.profile != undefined && this.profile.responsiblities != undefined) {
			this.profile.responsiblities.forEach((resp: any) => {
				if (resp) {
					if (
						resp.designation == 'ACADEMIC_AUDITOR' ||
						resp.designation == 'PRINCIPAL' ||
						resp.designation == 'COLLAGE_MGMT_REPRESENTATIVE' ||
						resp.designation == 'VICE_PRINCIPAL'
					) {
						admin = true;
						this.collegeAdminAllowed = true;
					}
					if (resp.designation == 'IQAC_ADMIN') {
						iqac = true;
					}
					if (resp.designation == 'CRITERIA_COORDINATOR') {
						this.criteriaOrdinatorAllowed = true;
						this.allowedCrietrias.push(resp?.criteria);
					}
				}
			});
			if (!iqac && admin) {
				this.onlyCollegeAdminAllowed = true;
			}
			if (this.criteriaOrdinatorAllowed && this.allowedCrietrias.length > 0) {
				this.allowedCrietrias = this.allowedCrietrias.sort(
					(a, b) => this.romanStringToInt(a) - this.romanStringToInt(b)
				);
			}
		}
	}

	async getLocalMetadata() {
		this.metadata = await this.userDataService.getMetadata();
		console.log('Navigation: getLocalMetadata() ');
		this.segregateSectionWiseFormList();
	}

	checkLoginStatus = async () => {
		// const loggedIn = await this.storage.get(UserDataService.HAS_LOGGED_IN);
		const loggedIn = await this.userDataService.isLoggedIn();
		console.log(`loggedIn from storage - ${loggedIn}`);
		this.updateLoggedInStatus(loggedIn);

		// return this.userDataService.isLoggedIn().then((loggedIn) => {
		//   return this.updateLoggedInStatus(loggedIn);
		// });
	};

	updateLoggedInStatus(loggedIn: boolean) {
		setTimeout(() => {
			this.isLoggedIn = loggedIn;
			// if logged in show the help widget
			if (this.platform.is('desktop')) {
				if (this.profile != undefined && this.profile.responsiblities != undefined) {
					let isSuperAdminorFacilitator = false;
					this.profile.responsiblities.forEach((resp: any) => {
						if (resp) {
							if (resp.designation == 'SUPER_ADMIN' || resp.designation == 'FACILITATOR') {
								isSuperAdminorFacilitator = true;
							}
						}
					});
					if (!isSuperAdminorFacilitator) {
						window['FreshworksWidget']('show');
						const launcherFrame = document.getElementById('launcher-frame');

						if (launcherFrame != null) {
							launcherFrame.style.maxWidth = '80px';
							launcherFrame.style.minWidth = '86px';
						}
					}
				}
			}
			if (
				this.platform.is('android') ||
				this.platform.is('ios') ||
				this.platform.is('mobile') ||
				this.platform.is('iphone')
			) {
				window['FreshworksWidget']('hide');
			}
			if (!loggedIn) {
				this.cleanupState();
			} else {
				this.checkwhichUserIsLogin();
			}
		}, 1000);
	}

	cleanupState() {
		this.profile = {};
		this.personalSectionForms = [];
		this.departmentSectionForms = [];
		this.iqacSectionForms = [];
		this.officeCoSectionForms = [];
		this.iqacSectionAllowed = false;
		this.personalSectionAllowed = false;
		this.departmentSectionAllowed = false;
		this.officeCoSectionAllowed = false;
		this.webc = false;
		this.isIQACADMIN = false;
		this.superUserLogin = false;
		this.isIQACCOADMIN = false;
		this.isIQACCOADMINOnly = false;
		window['FreshworksWidget']('hide');
	}

	updateLoggedInStatusInbox(loggedIn: boolean) {
		setTimeout(() => {
			this.isLoggedIn = loggedIn;
			if (!loggedIn) {
				this.cleanupState();
			} else {
				this.getFormLiteInfoForLoggedInUser();
				this.fetchuserProfile();
				this.getLocalMetadata();
			}
		}, 2000);
	}

	listenForLoginEvents() {
		if (this.loginListenersAdded) {
			return;
		}
		this.loginListenersAdded = true;
		window.addEventListener('user:login', () => {
			this.forcingLogout = false;
			this.updateLoggedInStatus(true);
		});

		window.addEventListener('user:signup', () => {
			this.updateLoggedInStatus(true);
		});

		window.addEventListener('user:logout', () => {
			this.updateLoggedInStatus(false);
		});

		window.addEventListener('user:force-logout', () => {
			// A rejected token fails every call on the page at once: sign out and show the toast only once.
			if (this.forcingLogout) {
				return;
			}
			this.forcingLogout = true;
			this.updateLoggedInStatus(false);
			this.userDataService.presentToast('You have been Logged out. Please re-login!', 'warning');
			// this.router.navigateByUrl('/login');
			this.userDataService.logout();
			this.navController.navigateRoot('/login');
		});

		window.addEventListener('form:quota-exhausted', () => {
			this.userDataService.presentToast('Form Quota Exhausted Contact To Admin!', 'danger');
		});
	}

	listenForLoginEventsForInbox() {
		if (this.inboxListenersAdded) {
			return;
		}
		this.inboxListenersAdded = true;
		window.addEventListener('inbox:login', () => {
			this.updateLoggedInStatusInbox(true);
		});

		window.addEventListener('inbox:signup', () => {
			this.updateLoggedInStatusInbox(true);
		});

		window.addEventListener('inbox:logout', () => {
			this.updateLoggedInStatusInbox(false);
		});

		window.addEventListener('inbox:profile-available', () => {
			this.fetchuserProfile();
		});

		window.addEventListener('user:refresh', () => {
			this.fetchUpdatedProfile();
		});
	}

	async checkwhichUserIsLogin() {
		const roles = await this.userDataService.getLoggedInUserRole();
		if (roles) {
			this.fetchuserProfile();
			if (roles.includes('SUPER_ADMIN')) {
				this.superUserLogin = true;
				this.isIQACADMIN = false;
				this.webc = false;
			} else if (roles.includes('IQAC_ADMIN')) {
				this.getProfileCompletionDetails();
				this.fetchAllCollegeTypeYearMappingsForCollegeId();
				this.isIQACADMIN = true;
				this.superUserLogin = false;
				// this.webc = false
			}
			if (roles.includes('WEB_EQUI')) {
				this.webc = true;
				this.superUserLogin = false;
				// this.isIQACADMIN = false;
			}
		} else {
			this.isLoggedIn = false;
			this.superUserLogin = false;
			this.isIQACADMIN = false;
			this.webc = false;
		}
		let iqac = false;
		let iqacCo = false;
		if (this.profile != undefined && this.profile.responsiblities != undefined) {
			this.profile.responsiblities.forEach((responsiblity) => {
				if (responsiblity) {
					if (responsiblity.designation == 'IQAC_CO_ADMIN') {
						iqacCo = true;
						this.isIQACCOADMIN = true;
					}
					if (responsiblity.designation == 'IQAC_ADMIN') {
						iqac = true;
					}
				}
			});
			if (!iqac && iqacCo) {
				this.isIQACCOADMINOnly = true;
			}
		}
	}
	checkwhichUserIsLoginInbox() {
		this.getFormLiteInfoForLoggedInUser();
	}
	async fetchuserProfile() {
		const profile = await this.userDataService.getUserProfile();
		if (profile) {
			this.profile = profile;
			if (this.profile.college != null) {
				this.subscriptionStatus = profile.college.status;
				if (this.subscriptionStatus == 'SUBS_EXPIRED') {
					this.isExpired = false;
				}
			}
		}
	}

	/* async confirmLogout() {
		const alert = await this.alertController.create({
			header: 'Logout!',
			message: 'Proceed with Logout?',
			buttons: [
				{
					text: 'Stay',
					role: 'cancel',
					handler: (blah) => {}
				},
				{
					text: 'Logout',
					cssClass: 'danger-bg',
					handler: () => {
						this.logout();
					}
				}
			]
		});
		await alert.present();

	}
 */

	async confirmLogout() {
		// Check if there are any unsaved changes (you can customize this logic)
		const hasUnsavedChanges = await this.checkForUnsavedChanges();

		const modal = await this.modalController.create({
			component: LogoutConfirmationModalComponent,
			componentProps: {
				userProfile: this.profile,
				hasUnsavedChanges: hasUnsavedChanges
			},
			cssClass: 'logout-confirmation-modal',
			backdropDismiss: false,
			showBackdrop: true
		});

		modal.present();

		modal.onDidDismiss().then((result) => {
			if (result.data && result.data.confirmed) {
				if (result.data.saveFirst) {
					// Handle save before logout if needed
					this.saveAndLogout();
				} else {
					this.logout();
				}
			}
			// If not confirmed, do nothing (stay logged in)
		});
	}

	// Helper method to check for unsaved changes
	private async checkForUnsavedChanges(): Promise<boolean> {
		// You can implement logic here to check if there are any unsaved forms or data
		// For now, we'll return false, but you can customize this based on your app's needs
		try {
			// Example: Check if there are any draft forms in storage
			const drafts = await this.userDataService.getStoredLiteForm();
			return drafts && drafts.length > 0;
		} catch (error) {
			return false;
		}
	}

	// Method to handle save and logout
	private async saveAndLogout() {
		try {
			// Implement any save logic here before logout
			// For example, save draft forms, sync data, etc.
			await this.saveDraftData();
			this.logout();
		} catch (error) {
			console.error('Error saving data before logout:', error);
			// Even if save fails, proceed with logout
			this.logout();
		}
	}

	// Helper method to save draft data
	private async saveDraftData(): Promise<void> {
		// Implement your save logic here
		// This is a placeholder - customize based on your app's needs
		return new Promise((resolve) => {
			setTimeout(() => {
				console.log('Draft data saved');
				resolve();
			}, 1000);
		});
	}

	async blackListedVersionAlert() {
		const alert = await this.alertController.create({
			header: 'Please Update',
			message: 'To enjoy our newest features.',
			backdropDismiss: false,
			buttons: [
				{
					text: 'Update',
					cssClass: 'Suceess-bg',
					handler: () => {
						// TODO handle this
						// this.market.open("in.easie.app").then((response) => {
						//   setTimeout(() => {
						//     window.location.reload();
						//   }, 2000);
						// });
					}
				}
			]
		});
		await alert.present();
	}

	async supportedVersionAlert() {
		const alert = await this.alertController.create({
			header: 'Warning!',
			message: 'There is an Update available! Please update to use this App.',
			backdropDismiss: false,
			buttons: [
				{
					text: 'Update',
					cssClass: 'Suceess-bg',
					handler: () => {
						// TODO handle this
						// this.market.open("in.easie.app").then((response) => {
						//   setTimeout(() => {
						//     window.location.reload();
						//   }, 2000);
						// });
					}
				},
				{
					text: 'Skip',
					role: 'cancel',
					handler: () => {
						this.userDataService.setIsSkipUpdate(true);
					}
				}
			]
		});
		await alert.present();
	}

	logout() {
		this.userDataService.logout().then(() => {
			this.isLoggedIn = false;
			this.userDataService.presentToast('Successfully Logged out.', 'warning');
			this.navController.setDirection('root');
			return this.router.navigateByUrl('/login', { replaceUrl: true });
		});
		this.authenticationService.logout();
		this.updateLoggedInStatus(false);
		this.updateLoggedInStatusInbox(false);
	}

	setActiveSection(activeSection: String) {
		this.userDataService.saveCurentSection(activeSection);
		this.activeSection = activeSection;
	}

	setCurrentCriteria(currentCriteria: String) {
		this.currentCriteria = currentCriteria;
		this.userDataService.saveCurrentCriteria(currentCriteria);
	}

	async fetchUpdatedProfile() {
		const token = await this.userDataService.getToken();
		if (token) {
			const profile = await this.userDataService.getUserProfile();
			if (profile) {
				const latestProfile = await this.userProfileService.getUserProfileAxios(token, profile.emailId);
				this.profile = latestProfile;
				await this.userDataService.saveUserProfile(latestProfile);
				const tokenDTO = await this.userProfileService.fetchTokenDtoObjectAxios(token, latestProfile);
				await this.userDataService.saveSecurityToken(tokenDTO);
				console.log('Navigation: fetchUpdatedProfile() ');
				await this.segregateSectionWiseFormList();

				// this.userProfileService.getUserProfile(token, profile.emailId).subscribe((profile) => {
				//   this.profile = profile;
				//   this.userDataService.saveUserProfile(profile).then((response) => {
				//     this.userProfileService.fetchTokenDtoObject(token, profile).subscribe((tokenDTO) => {
				//       this.userDataService.saveSecurityToken(tokenDTO).then((token) => {
				//         this.segregateSectionWiseFormList();
				//       });
				//     });
				//   });
				// });
			}
		}
	}

	async formQuota() {
		const roles = await this.userDataService.getLoggedInUserRole();
		if (roles && !roles.includes('SUPER_ADMIN')) {
			const loggedIn = await this.userDataService.isLoggedIn();
			if (loggedIn) {
				let token = await this.userDataService.getToken();
				const userQuota = await this.dashboardService.getUserQuotaAxios(token);
				if (userQuota.quotaExhausted) {
					this.quotaExhausted = false;
				}
			}
		}
	}

	async handleActiveNavigation() {
		const activeSection = await this.userDataService.getCurrentActiveSection();
		this.activeSection = activeSection;
	}

	async applySafeArea() {
		await (SafeArea as unknown as any).enable?.({
			config: {
				customColorsForSystemBars: true,
				statusBarColor: '#388c81', // transparent
				statusBarContent: 'light',
				navigationBarColor: '#8ddcc3', // transparent
				navigationBarContent: 'light'
			}
		});

		// const { insets } = await SafeArea.getSafeAreaInsets();

		// document.documentElement.style.setProperty('--safe-area-inset-top', `${insets.top}px`);
		// document.documentElement.style.setProperty('--safe-area-inset-bottom', `${insets.bottom}px`);
		// document.documentElement.style.setProperty('--safe-area-inset-left', `${insets.left}px`);
		// document.documentElement.style.setProperty('--safe-area-inset-right', `${insets.right}px`);
	}

	listenForSafeAreaChanges() {
		// SafeArea.addListener('safeAreaChanged', ({ insets }) => {
		//   document.documentElement.style.setProperty('--safe-area-inset-top', `${insets.top}px`);
		//   document.documentElement.style.setProperty('--safe-area-inset-bottom', `${insets.bottom}px`);
		//   document.documentElement.style.setProperty('--safe-area-inset-left', `${insets.left}px`);
		//   document.documentElement.style.setProperty('--safe-area-inset-right', `${insets.right}px`);
		// });
	}
}
